export enum RacingEventTypes {
    RaceCard = 341,
    TrapMarket = 760,
    BettingWithoutFav = 767,
    PlaceOnly = 768,
    MatchBetting = 769,
    BettingWithoutTwoFav = 770,
    AUHRPlaceOnly = 784,
    AUHRTote = 785,
    AUHRTotePlaceOnly = 786
};
export enum PushMessageTypes {
    Odds = "OddsMessage",
    Sogei = "SogeiID",
    UserBets = "UserBets",
}

export enum BranchViewEventsType {
    TodaysEvents = 0,
    TomorrowEvents = 1,
    FutureEvents = 2
}